import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import React, { forwardRef, useImperativeHandle, useState } from "react";
import Label from "../Label";
import TextInput from "../TextInputs";
import globalStyle from "../../globalStyle";
import appcolors from "../../constants/Colors";
import GlobalButton from "../CustomButton";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
  "& .MuiPaper-root": {
    // width: "500px",
    [theme.breakpoints.down("sm")]: {
      margin: 12,
    },
  },
  "& .MuiDialogContent-root": {
    padding: "0 2rem",
    [theme.breakpoints.down("sm")]: {
      padding: "0 8px",
    },
  },
  "& .MuiDialogActions-root": {
    padding: "25px 16px",
    [theme.breakpoints.down("sm")]: {
      padding: "25px  8px",
    },
  },
}));
let paramsData = {};

const CategoryBlockDialog = forwardRef((props, ref) => {
  const { handleConfirm, open, setOpen } = props;
  useImperativeHandle(ref, () => ({
    isVisible(params) {
      paramsData = params;
      setOpen(true);
    },
  }));

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <BootstrapDialog
      onClose={handleClose}
      aria-labelledby="customized-dialog-title"
      open={open}
    >
      <DialogTitle
        sx={{
          m: 0,
          p: 2,
          fontSize: "1.5rem",
          fontWeight: 600,
          textAlign: "center",
        }}
        id="customized-dialog-title"
      >
        Confirmation !
      </DialogTitle>
      <DialogContent sx={{ padding: { xs: "0px 0px !impor", md: "0px 20px" } }}>
        <Typography variant="body2" my={1}>
          Are ,You sure you want to delete this category?
        </Typography>
        <Typography variant="body2" my={1} color={"primary.main"}>
          Note: This action make effect on business owner performance
        </Typography>
      </DialogContent>
      <DialogActions>
        <GlobalButton
          variant={"outlined"}
          btnText={"Cancel"}
          handleClickBtn={handleClose}
        />
        <GlobalButton
          variant={"contained"}
          btnText={"Yes"}
          handleClickBtn={() => {
            handleConfirm(paramsData);
          }}
        />
      </DialogActions>
    </BootstrapDialog>
  );
});

export default CategoryBlockDialog;
